import { render, staticRenderFns } from "./SorteadorDeNumeros.vue?vue&type=template&id=434e92c0&scoped=true&"
import script from "./SorteadorDeNumeros.vue?vue&type=script&lang=js&"
export * from "./SorteadorDeNumeros.vue?vue&type=script&lang=js&"
import style0 from "./SorteadorDeNumeros.vue?vue&type=style&index=0&id=434e92c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434e92c0",
  null
  
)

export default component.exports